<div style="background: #ffeeff" class="h-100 overflow-auto crm-scroll">
  <app-sidebar-header (close)="close.emit()" [title]="('integration' | translate) + ' Telegram'"></app-sidebar-header>
  <mat-card class="shadow-none bg-transparent">
    <mat-card-content class="m-3 p-3 bg-white rounded-2 d-flex flex-column gap-2">
      <div class="integration-info-container">
        <div class="integration-img-container">
          <img class="integration-img" src="/assets/svgs/integrations/telegram.svg" alt="Telegram logo" />
        </div>

        <div class="integration-info">
          @if (!alreadyAuth) {
            <span class="integration-info-title">{{ 'log_in_with_your_telegram_account' | translate }}</span>
          }
          <span>{{ 'channel' | translate }}: {{ channelName }}</span>
          <span>
            {{ 'integration' | translate }}:
            <span class="text-success"> {{ alreadyAuth ? 'встановлена ' : 'не встановлена' }}</span>
          </span>
          @if (alreadyAuth) {
            <app-button btnType="stroked" (onChangeClick)="onLogOut()" [disabled]="loading">
              {{ 'exit' | translate }}
            </app-button>
          }
          <div class="container-copy">
            <app-button (onChangeClick)="copyChannelId()">
              {{ 'copy_channel_ID' | translate }}
            </app-button>
          </div>
        </div>
      </div>

      @if (qrCode) {
        <div class="type-login-block">
          <div class="integration-form">
            <div #qrcode class="qrcode"></div>
            <ng-container *ngTemplateOutlet="passwordInput" />
          </div>
          @if (!password) {
            <app-button (onChangeClick)="openPhoneLogin()" btnType="stroked" [disabled]="loading">
              {{ 'login_with_phone' | translate }}
            </app-button>
          }
        </div>
      }

      @if (!qrCode) {
        <div class="type-login-block">
          <div class="integration-form">
            <ng-container *ngTemplateOutlet="phoneInput" />
            <ng-container *ngTemplateOutlet="codeInput" />
            <ng-container *ngTemplateOutlet="passwordInput" />
          </div>
          @if (!phoneCode && !alreadyAuth) {
            <app-button (onChangeClick)="openQrLogin()" btnType="stroked" [disabled]="loading">
              {{ 'login_with_qr' | translate }}
            </app-button>
          }
        </div>
      }
    </mat-card-content>
  </mat-card>

  <app-integration-review [youtubeReviewLink]="'https://www.youtube.com/watch?v=hkLuuMCeKuk'"></app-integration-review>
</div>

<ng-template #phoneInput>
  <form class="integration-form-item" [formGroup]="formGroup">
    <app-phone-field
      [formControl]="formGroup.controls.phoneNumber"
      label="{{ 'phone' | translate }}"
      [error]="formGroup.controls.phoneNumber.touched && formGroup.controls.phoneNumber.invalid"
      [disabled]="!!phoneCode || alreadyAuth || loading"
      (keydown.enter)="onSendCode()"
    />
    @if (formGroup.controls.phoneNumber.touched && formGroup.controls.phoneNumber.invalid) {
      <mat-hint class="text-danger field-hint">
        {{ 'field_cannot_be_empty' | translate }}
      </mat-hint>
    }

    @if (!phoneCode && !alreadyAuth) {
      <app-button class="form-buttons" (onChangeClick)="onSendCode()" [disabled]="loading">
        {{ 'next' | translate }}
      </app-button>
    }
  </form>
</ng-template>

<ng-template #codeInput>
  @if (phoneCode) {
    <div class="integration-form-item">
      <app-text-field
        [formControl]="phoneCode"
        [autofocus]="true"
        label="{{ 'code' | translate }}"
        [maxLength]="6"
        [error]="phoneCode.touched && phoneCode.invalid"
        [disabled]="!!password || loading"
        (keydown.enter)="onVerifyCode()"
      />
      @if (phoneCode.touched && phoneCode.invalid) {
        <mat-hint class="text-danger field-hint">
          {{ 'field_cannot_be_empty' | translate }}
        </mat-hint>
      }
      @if (!password) {
        <div class="form-buttons">
          <app-button (onChangeClick)="onVerifyCode()" [disabled]="loading">
            {{ 'next' | translate }}
          </app-button>
          <app-button btnType="cancel" (onChangeClick)="onCancelCode()" [disabled]="loading">
            {{ 'cancel' | translate }}
          </app-button>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #passwordInput>
  @if (password) {
    <div class="integration-form-item">
      <app-text-field
        [formControl]="password"
        [autofocus]="true"
        label="{{ 'password' | translate }}"
        [isPassword]="true"
        [error]="password.touched && password.invalid"
        [disabled]="loading"
        (keydown.enter)="onSignInWithPassword()"
      />
      @if (password.touched && password.invalid) {
        <mat-hint class="text-danger field-hint">
          {{ 'field_cannot_be_empty' | translate }}
        </mat-hint>
      }
      <app-button class="form-buttons" (onChangeClick)="onSignInWithPassword()" [disabled]="loading">
        {{ 'next' | translate }}
      </app-button>
    </div>
  }
</ng-template>
